// 导入vue 组件
const importFn = require.context('./', false, /\.vue$/)

export default {
  install (app) {
    // 循环遍历每个vue组件的路径
    importFn.keys().forEach(key => {
      // 通过路径获得每个vue 组件
      const component = importFn(key).default
      // 注册
      app.component(component.name, component)
    })
  },
}



// WEBPACK FOOTER //
// ./src/components/index.js